export const PROTOCOL_ID = "browsermcp.bridge";
export const PROTOCOL_VERSION = "1.1.0";
export const SUPPORTED_PROTOCOL_VERSIONS = [PROTOCOL_VERSION, "1.0.0"];
export const KNOWN_PROTOCOL_CAPABILITIES = [
    "tools",
    "resources",
    "prompts",
    "cancellation",
    "session-resume",
    "heartbeat",
];
export const KNOWN_PROTOCOL_ERROR_CODES = [
    "AUTH_REQUIRED",
    "AUTH_INVALID",
    "AUTH_EXPIRED",
    "APPROVAL_REJECTED",
    "APPROVAL_EXPIRED",
    "ORIGIN_NOT_ALLOWED",
    "VERSION_UNSUPPORTED",
    "CAPABILITY_UNSUPPORTED",
    "INVALID_MESSAGE",
    "REGISTRATION_REJECTED",
    "REGISTRATION_NOT_FOUND",
    "INVOCATION_NOT_FOUND",
    "INVOCATION_TIMEOUT",
    "INVOCATION_CANCELLED",
    "HANDLER_ERROR",
    "SESSION_EXPIRED",
    "SESSION_RESUME_REJECTED",
    "RATE_LIMITED",
    "CONNECTION_CLOSED",
    "INTERNAL_ERROR",
];
//# sourceMappingURL=types.js.map